//
// PrintTableOfContentsDisplayOption.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var PrintTableOfContentsDisplayOption = {
    READERDEFAULT:0,
    NONE:1,
    BOOKMARKS:2,
    THUMBNAILS:3
};
export default PrintTableOfContentsDisplayOption;
